export const FETCH_EMAIL_REPORTS_LIST = 'FETCH_EMAIL_REPORTS_LIST'
export const FETCH_PAGINATED_EMAIL_REPORTS_LIST = 'FETCH_PAGINATED_EMAIL_REPORTS_LIST'

export const FETCH_EMAIL_REPORT = 'FETCH_EMAIL_REPORT'

export const FETCH_EMAIL_REPORT_DETAILS = 'FETCH_EMAIL_REPORT_DETAILS'
export const FETCH_PAGINATED_EMAIL_REPORT_DETAILS = 'FETCH_PAGINATED_EMAIL_REPORT_DETAILS'
export const FETCH_EMAIL_SUMMARY = 'FETCH_EMAIL_SUMMARY'

export const FETCH_SCHEDULED_EMAILS = 'FETCH_SCHEDULED_EMAILS'